import { get, post, put, del } from '@/utils/request'

// 获取课程列表
export function getCourses(params) {
  return get('/course',params)
}

// 获取课程详情
export function getCourseDetail(id) {
  return get(`/course/${id}`)
}

// 创建课程
export function createCourse(data) {
  return post('/manage/course', data)
}

// 更新课程
export function updateCourse(id, data) {
  return put(`/manage/course/${id}`, data)
}

export function updateCourseLabels(data) {
  return put(`/manage/updateCourseLabels`, data)
}

// 删除课程
export function deleteCourse(id) {
  return del(`/manage/course/${id}`)
}


export function updateCourseOrder(data) {
  return put(`/manage/courseSort`, data)
}